import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";

const {UniversalModal} = Framework.Elements;
const breadcrumbsStatic = [
	{
		name: 'Customers',
		url: '/customers',
		icon: 'user',
	}
];

export default class Customers extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-consignment" onClick={this.toggle('modalCustomer')} size={"sm"}
					        className="primary-button">
						<i className="fa fa-user"/>&nbsp;&nbsp;Add Customer
					</Button>
				</Framework.Components.PageBar>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Customers
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</Framework.Errors.General>

				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={"Customer"}
					object={Objects.Customer}
					history={this.props.history}
					toggle={this.state['modalCustomer']}
					reportClose={this.reportClose('modalCustomer')}
					afterSave={this.handleAfterSave}
					size={'lg'}
					objectProps={{
						hideSave: true
					}}
					project={'pos'}
				/>

			</div>
		);
	}
}
